import { connect } from 'react-redux';

import ActionGroupInputEditorWrapper from 'app/developer-v3/pages/actions/ActionGroupInputEditor/ActionGroupInputEditorWrapper';
import {
  allServicesByType,
  availableTriggers,
  isCurrentAppDefinitionSaving,
} from 'app/developer-v3/selectors';
import { SERVICE_TYPE } from 'app/developer-v3/constants';

const mapStateToProps = state => ({
  isSaving: isCurrentAppDefinitionSaving(state),
  searches: allServicesByType(SERVICE_TYPE.searches, state),
  availableTriggers: availableTriggers(state),
});

export default connect(mapStateToProps)(ActionGroupInputEditorWrapper);
